const uploaderServiceName = "/FileUploader"
const mediaOperationServiceName = "/MediaOperation"
export function fileUploaderService(http) {
    
    return {
        singleFileUpload(data){
            return http.post(uploaderServiceName + "/UploadSingleFile", data);
        },
        async uploadFileChunks(data, params){
            return await http.post(uploaderServiceName + "/UploadFileChunks", data, params);
        },
        async uploadFileComplete(data, params){
            return await http.post(uploaderServiceName + "/UploadFileComplete", data, params);
        },
        async SaveMedia(data){
            return await http.post(mediaOperationServiceName + "/SaveMediaFile", data);
        }
    }
}